module.exports = __webpack_public_path__ + "static/media/curriculumKit__creative.96169cf1.svg";